export default "__VITE_ASSET__CrI30LMZ__"